'use client';

import { LoadingSpinnerIcon } from '@/assets/icons/LoadingSpinner';
import { TextInput } from '@/components/inputs/TextInput';
import { Button } from '@/components/ui/Button';
import { SearchIcon } from 'lucide-react';
import { ExitIcon } from '../ExitIcon';
import { useBlogHeaderSearch } from '../useBlogHeaderSearch';

import './BlogHeaderSearchIcon.scss';

type Props = {
  onClick: () => void;
  isSearching: boolean;
  searchTerm?: string;
};

export const BlogHeaderSearchIcon: React.FC<Props> = ({
  onClick,
  isSearching,
  searchTerm: _searchTerm = '',
}) => {
  const {
    searchTerm,
    handleKeyDown,
    handleSearch,
    loading: redirectLoading,
    handleSearchTermChange,
    error,
  } = useBlogHeaderSearch();

  return (
    <div className='BlogHeaderSearchIcon flex-column .relative flex items-center'>
      {isSearching && (
        <div className='BlogHeaderSearchIcon__input-wrapper'>
          <TextInput
            className='BlogHeaderSearchIcon__input'
            placeholder='Search'
            name='search'
            onKeyDown={handleKeyDown}
            onChange={handleSearchTermChange}
            value={searchTerm}
            type='text'
          />

          <SearchIcon
            className='BlogHeaderSearchIcon__input-icon'
            onClick={handleSearch}
            size={24}
          />

          {error && (
            <p className='BlogHeaderSearchIcon__error mt-1 text-sm text-red-500'>
              {error}
            </p>
          )}
        </div>
      )}

      <Button
        className='BlogHeaderSearchIcon__button'
        onClick={onClick}
        variant='ghost'
      >
        {!isSearching && <SearchIcon size={24} />}

        {isSearching && <ExitIcon />}

        {redirectLoading && (
          <div className='BlogHeaderSearchIcon__loading-spinner'>
            <LoadingSpinnerIcon />
          </div>
        )}
      </Button>
    </div>
  );
};
